import React from 'react';
import { Alert, Badge, Card, Col, Row } from 'react-bootstrap';
import DocumentUpload from './DocumentUpload';
import DocumentStatusSummary from './DocumentStatusSummary';
import FillableTemplates from './FillableTemplates';

const ComplianceCenter = ({ documentData = null, registrationDate = null }) => (
  <div>
    <Card className="shadow-sm border-0 mb-4">
      <Card.Body>
        <div className="d-flex flex-wrap justify-content-between align-items-start gap-3">
          <div>
            <h4 className="mb-2">Compliance Centre</h4>
            <p className="text-muted mb-2">
              Manage all learner compliance work in one place. Upload required documents, track QA
              review outcomes, and complete any template-based forms without switching between
              separate LMS sections.
            </p>
            <div className="small text-muted">
              Some items require a direct upload. Others require you to download a template,
              complete it, and submit it back below in the same compliance centre.
            </div>
          </div>
          <Badge bg="primary" pill>
            Unified Compliance View
          </Badge>
        </div>
      </Card.Body>
    </Card>

    <Alert variant="info" className="mb-4">
      <strong>How this works:</strong> use the upload panel for required compliance documents,
      check the live status panel for missing/pending/rejected items, and use the template section
      for forms that must first be downloaded and completed.
    </Alert>

    <Row className="g-4">
      <Col xl={6}>
        <DocumentUpload />
      </Col>
      <Col xl={6}>
        <DocumentStatusSummary
          documentData={documentData}
          registrationDate={registrationDate}
        />
      </Col>
    </Row>

    <Row className="mt-4">
      <Col>
        <Card className="shadow-sm border-0">
          <Card.Header className="bg-white">
            <h5 className="mb-0">Compliance Templates and Forms</h5>
          </Card.Header>
          <Card.Body>
            <FillableTemplates />
          </Card.Body>
        </Card>
      </Col>
    </Row>
  </div>
);

export default ComplianceCenter;
